import { observable, computed, action } from 'mobx';
import { App, ArrayApp, AppRegistry } from 'core';
import { FormStore } from 'libs/forms/app';
import { IssueModel } from 'apps/issueTracker/models';

import { conf as tagsConf } from 'apps/tag/config.yaml';
import { conf } from 'apps/issueTracker/config.yaml';

import { modalStore } from 'apps/modals/app';
import { OneColumnLayout } from 'apps/layout';

export class IssueApp extends App {
  static registryName = 'IssueApp';
  static AppProps = {
    creatorProfile: 'ProfileApp',
    labels: 'LabelsApp',
    commenters: 'ProfilesApp',
    assignees: 'ProfilesApp',
    inSpace: 'SpaceApp',
    project: 'ProjectApp',
    tags: 'TagsApp',
  };

  static Model = IssueModel;

  @observable editing = false;

  @computed get route() {
    if (!(this.slug && this.project)) return {};
    return {
      name: `${this.project.route.name}.issue`,
      params: { ...this.project.route.params, issueSlug: this.slug },
    };
  }

  createForm() {
    this.form = new FormStore(this, conf, 'issueForm');
  }

  addLabels() {
    this.addLabelsForm = new FormStore(this, conf, 'addLabelsForm');
  }

  addAssignees() {
    this.addAssigneesForm = new FormStore(this, conf, 'addAssigneesForm');
  }

  @action SetEditing = editing => {
    this.editing = editing;
  };

  @action CloseIssue = () => {
    this.status = 'Closed';
  };

  @action ReOpenIssue = () => {
    this.status = 'Open';
  };

  @action Delete = () => {
    this.deleted = true;
  };

  @action EditTags = () => {
    this.editTagsFormStore = new FormStore(this, tagsConf, 'editStoryTags');
  };

  @action DoneEditingTags = () => {
    modalStore.ClearComponent();
    this.editTagsFormStore = null;
  };
}
AppRegistry.add(IssueApp);

export class IssueArrayApp extends ArrayApp {
  static registryName = 'IssueArrayApp';
  static ElementApp = IssueApp;
  cardLayout = new OneColumnLayout();
}
AppRegistry.add(IssueArrayApp);
